<template>
  <div class="container">
    <div
      class="bg-blue p-2 rounded"
    >Para sua segurança precisamos confirmar os dados das duas contas. A transferência pode levar alguns minutos para ser concluída dependendo do número de dispositivos e quantidade de dados.</div>

    <form action @submit="validate">
      <div class="vx-row">
        <div class="vx-col w-full mb-base">
          <vx-card>
            <div class="my-6 text-center">
              <h1 class="m-4 mb-2">Conta de Origem</h1>
              <h6 class="m-4 mb-2">Essa é a conta da qual vamos tirar os dispositivos.</h6>

              <div class="vx-row">
                <div class="vx-col w-full md:w-1/2 mb-base">
                  <vs-input
                    name="email"
                    icon="icon icon-user"
                    icon-pack="feather"
                    label-placeholder="Email da Conta de Origem"
                    v-model.trim="outgoing.email"
                    autocomplete="off"
                    :disabled="valid"
                    class="w-full no-icon-border"
                  />
                </div>

                <div class="vx-col w-full md:w-1/2 mb-base">
                  <vs-input
                    data-vv-validate-on="blur"
                    v-validate="'required|min:6|max:30'"
                    type="password"
                    name="password"
                    icon="icon icon-lock"
                    icon-pack="feather"
                    label-placeholder="Senha da Conta de Origem"
                    v-model.trim="outgoing.password"
                    autocomplete="off"
                    :disabled="valid"
                    class="w-full no-icon-border"
                  />
                </div>
              </div>
            </div>

            <div
              class="bg-danger text-white p-2 text-center rounded"
              v-if="valid && (!outgoing.mobile.length && !outgoing.desktop.length)"
            >Essa conta não possui nenhum dispositivo.</div>

            <div class="my-6 text-center" v-if="outgoing.mobile.length || outgoing.desktop.length">
              <h1 class="m-4 mb-2">Dispositivos</h1>
              <h6 class="m-4 mb-2">Os dispositivos abaixo serão movidos para a conta de destino.</h6>

              <div class="w-full" v-for="mobile in outgoing.mobile.v4" :key="mobile.uid">
                <i class="fas fa-mobile-alt text-primary"></i>
                {{mobile.alias || mobile.device}} (v{{mobile.apkversion}})
              </div>
              <div class="w-full" v-for="desktop in outgoing.desktop" :key="desktop.id">
                <i class="fas fa-desktop-alt text-success"></i>
                {{desktop.alias || desktop.licencekey}}
              </div>

              <h6 class="m-4 mb-2" v-show="outgoing.mobile.v3.length">ATENÇÃO: Os dispositivos abaixo NÃO serão movidos para a conta de destino, pois estão numa versão incompatível.</h6>
              <div class="w-full" v-for="mobile in outgoing.mobile.v3" :key="mobile.uid">
                <i class="fas fa-mobile-alt text-primary"></i>
                {{mobile.alias || mobile.device}} (v{{mobile.apkversion}})
              </div>
            </div>
          </vx-card>
        </div>
        <div class="vx-col w-full mb-base">
          <vx-card>
            <div class="my-6 text-center">
              <h1 class="m-4 mb-2">Conta de Destino</h1>
              <h6 class="m-4 mb-2">Essa é a conta na qual vamos colocar os dispositivos.</h6>

              <div class="vx-row">
                <div class="vx-col w-full md:w-1/2 mb-base">
                  <vs-input
                    name="email"
                    icon="icon icon-user"
                    icon-pack="feather"
                    label-placeholder="Email da Conta de Origem"
                    v-model.trim="incoming.email"
                    autocomplete="off"
                    :disabled="valid"
                    class="w-full no-icon-border"
                  />
                </div>
                <div class="vx-col w-full md:w-1/2 mb-base">
                  <vs-input
                    data-vv-validate-on="blur"
                    v-validate="'required|min:6|max:30'"
                    type="password"
                    name="password"
                    icon="icon icon-lock"
                    icon-pack="feather"
                    label-placeholder="Senha da Conta de Origem"
                    v-model.trim="incoming.password"
                    autocomplete="off"
                    :disabled="valid"
                    class="w-full no-icon-border"
                  />
                </div>
              </div>
            </div>

            <div
              class="my-6 text-center"
              v-if="valid && !incoming.mobile.length && !incoming.desktop.length"
            >Esta conta não possui nenhum dispositivo.</div>

            <div class="my-6 text-center" v-if="incoming.mobile.length || incoming.desktop.length">
              <h1 class="m-4 mb-2">Dispositivos</h1>
              <h6 class="m-4 mb-2">Os dispositivos abaixo não serão afetados.</h6>

              <div class="w-full" v-for="mobile in incoming.mobile" :key="mobile.uid">
                <i class="fas fa-mobile-alt text-primary"></i>
                {{mobile.alias || mobile.device}}
              </div>
              <div class="w-full" v-for="desktop in incoming.desktop" :key="desktop.id">
                <i class="fas fa-desktop-alt text-success"></i>
                {{desktop.alias || desktop.licencekey}}
              </div>
            </div>
          </vx-card>
        </div>
        <div class="vx-col w-full mb-base text-center" v-if="!valid">
          <vs-button color="primary" class="w-full mt-4 md:w-auto" :disabled="processing" @click="validate">
            <i class="far fa-arrow-circle-right"></i> Validar Contas
          </vs-button>
          <button type="submit" style="display: none"></button>
        </div>
        <div class="vx-col w-full mb-base text-center" v-if="valid">
          <vs-button
            color="success"
            class="w-full mt-4 md:w-auto"
            v-if="outgoing.mobile.length || outgoing.desktop.length"
            :disabled="processing"
            @click="transfer()"
          >
            <i class="far fa-arrow-circle-right"></i> Migrar Dispositivos
          </vs-button>
          <vs-button
            color="success"
            class="w-full mt-4 md:w-auto"
            v-if="!outgoing.mobile.length && !outgoing.desktop.length"
            @click="reset()"
          >
            <i class="far fa-eraser"></i> Recomeçar
          </vs-button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      outgoing: {
        email: "",
        password: "",
        mobile: [],
        desktop: []
      },
      incoming: {
        email: "",
        password: "",
        mobile: [],
        desktop: []
      },
      processing: false,
      valid: false
    };
  },
  mounted() {},
  methods: {
    validate(e) {
      e.preventDefault();

      this.processing = true;

      this.$api
        .post("/api/v1/device-transfer/validate", {
          outgoing: this.outgoing,
          incoming: this.incoming
        })
        .then(response => {
          this.processing = false;
          this.valid = true;
          this.outgoing.mobile = response.data.outgoing.mobile;
          this.outgoing.desktop = response.data.outgoing.desktop;
          this.incoming.mobile = response.data.incoming.mobile;
          this.incoming.desktop = response.data.incoming.desktop;
        })
        .catch(error => {
          this.processing = false;

          this.$vs.notify({
            time: 6000,
            title: "Aviso",
            text: error.response.data.error || error.response.data.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger"
          });
        });
    },
    reset() {
      this.outgoing = {
        email: "",
        password: "",
        mobile: [],
        desktop: []
      };

      this.incoming = {
        email: "",
        password: "",
        mobile: [],
        desktop: []
      };

      this.valid = false;
    },
    transfer() {
      this.processing = true;

      this.$api
        .post("/api/v1/device-transfer/execute", {
          outgoing: this.outgoing,
          incoming: this.incoming
        })
        .then(() => {
          this.$router.push("/dispositivo");

          this.$vs.notify({
            time: 8000,
            text:
              "Os dispositivos serão migrados em breve para a conta de destino.",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success"
          });
        })
        .catch(error => {
          this.processing = false;

          this.$vs.notify({
            time: 6000,
            title: "Aviso",
            text: error.response.data.error || error.response.data.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger"
          });
        });
    }
  }
};
</script>
